export default "__VITE_ASSET__D1udDgYh__"